export class StorageEnum{
    public static getUserAccessToken ='userAccessToken';
    public static getUserRefreshToken ='userRefreshToken';
    public static getPersonName ='personName';
    public static getMenuHeaderList = 'menuHeaderList';
    public static getMenuIdList ='menuIdList';
    public static getMenuNameList ='menuNameList';
    public static getSelectedMenuId = 'selectedMenuId';
    public static getSelectedMenuName = 'selectedMenuName';
    public static getUserName ='userName';
    public static getEmployeeId ='employeeId';
    public static getEmailOrMobileNo = 'emailOrMobileNo';
    public static getUserRole = 'userRole';
}
